/* fetc-policy-sidenav.js
   FETC CUSTOM: Policy page — DOM restructure, mobile select, table scroll (Redesign 2026)
*/
(function () {
  'use strict';

  /* Only run on policy pages */
  if (!document.getElementById('fetc-policy-prose-col')) return;

  /* 1. DOM restructure: move .shopify-policy__container into the prose column.
        Shopify outputs .shopify-policy__container after our snippet, outside #fetc-policy-layout.
        We move it inside .fetc-policy-prose-col to complete the 2-col grid. */
  function restructureLayout() {
    var proseCol = document.getElementById('fetc-policy-prose-col');
    var shopifyContainer = document.querySelector('.shopify-policy__container');
    if (proseCol && shopifyContainer && shopifyContainer.parentNode !== proseCol) {
      proseCol.appendChild(shopifyContainer);
    }
  }

  /* 2. Dateline: insert below Shopify policy title */
  function injectDateline() {
    var title = document.querySelector('.shopify-policy__title');
    if (!title) return;
    if (title.nextElementSibling && title.nextElementSibling.classList.contains('fetc-policy-header__meta')) return;
    var meta = document.createElement('p');
    meta.className = 'fetc-policy-header__meta';
    meta.textContent = 'Last updated: May 2026';
    title.insertAdjacentElement('afterend', meta);
  }

  /* 3. CTA strip: append below prose */
  function appendCta() {
    var proseCol = document.getElementById('fetc-policy-prose-col');
    if (!proseCol) return;
    if (proseCol.querySelector('.fetc-policy-cta')) return; /* already added */
    var cta = document.createElement('div');
    cta.className = 'fetc-policy-cta';
    /* Contact URL: read from sidenav data-contact-url attribute set by Liquid,
       or fallback to /pages/contact (locale prefix added by Shopify router on navigation) */
    var layout = document.getElementById('fetc-policy-layout');
    var contactUrl = (layout && layout.dataset.contactUrl) ? layout.dataset.contactUrl : '/pages/contact';
    cta.innerHTML =
      '<p class="fetc-policy-cta__text">Questions about an order?</p>' +
      '<a href="' + contactUrl + '" class="link-arrow">Contact us</a>';
    proseCol.appendChild(cta);
  }

  /* 4. Wrap tables for horizontal scroll */
  function wrapTables() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    var tables = body.querySelectorAll('table');
    tables.forEach(function (table) {
      if (table.parentNode.classList.contains('fetc-policy-table-wrap')) return;
      /* FETC CUSTOM: UX-29 — SCROLL hint + a11y attrs. mock pg-policy.html:294-295 */
      var hint = document.createElement('p');
      hint.className = 'policy-table-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = 'Scroll →';
      var wrap = document.createElement('div');
      wrap.className = 'fetc-policy-table-wrap';
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', 'Shipping rates by region (scrollable)');
      table.parentNode.insertBefore(hint, table);
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
      /* END FETC CUSTOM */
    });
  }

  /* 5. Mobile select: navigate on change (CSP-safe) */
  function bindMobileSelect() {
    var sel = document.getElementById('fetc-policy-select');
    if (sel) {
      sel.addEventListener('change', function () {
        if (this.value) window.location.href = this.value;
      });
    }
  }

  /* Run after DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      restructureLayout();
      injectDateline();
      appendCta();
      wrapTables();
      bindMobileSelect();
    });
  } else {
    restructureLayout();
    injectDateline();
    appendCta();
    wrapTables();
    bindMobileSelect();
  }
})();
